import { createFileRoute } from '@tanstack/react-router'
import { Quadros } from '@/features/tarefas/Quadros'

export const Route = createFileRoute('/_app/app/tarefas/')({
  staticData: { crumb: { label: 'Tarefas' } },
  component: Quadros,
})
